var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-terms-and-conditions prose"},[_c('div',{staticClass:"page-terms-and-conditions__body container"},[_c('LegalPagesNavigation'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.markdown)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }